import { createApi } from '@reduxjs/toolkit/query/react'
import { MANAGE_NOTE_ADD, MANAGE_NOTE_EDIT, MANAGE_NOTE_PIN, MANAGE_NOTE_REMOVE, MANAGE_NOTE_VIEW } from "config/apiPaths"
import axiosBaseQuery from "utils/axios/axiosBaseQuery"

export const noteApi = createApi({

    reducerPath: 'noteApi',
    baseQuery: axiosBaseQuery({
        baseUrl: "/note",
    }),
    tagTypes: ["Notes", "NoteDetails"],
    endpoints: (builder) => ({

        // create note
        createNote: builder.mutation({
            query: (data) => ({
                method: "POST",
                url: MANAGE_NOTE_ADD,
                data
            }),
            invalidatesTags: ["NoteDetails"]
        }),

        // update note
        updateNote: builder.mutation({
            query: ({ data, id }) => ({
                method: "PUT",
                url: `${MANAGE_NOTE_EDIT}/${id}`,
                data
            }),
            invalidatesTags: ["NoteDetails"]
        }),

        // Get Note
        getNote: builder.query({
            query: ({ clientId, moduleName }) => ({
                method: "GET",
                url: `${MANAGE_NOTE_VIEW}/${clientId}/${moduleName}`,
            }),
            providesTags: ["NoteDetails"],
            transformResponse: (response) => {
                return response.data;
            },
        }),

        // delete note
        deleteNote: builder.mutation({
            query: (id) => ({
                method: "DELETE",
                url: `${MANAGE_NOTE_REMOVE}/${id}`
            }),
            invalidatesTags: ["NoteDetails"]
        }),

        // pin note
        pinNote: builder.mutation({
            query: ({ id, data }) => ({
                method: "PUT",
                url: `${MANAGE_NOTE_PIN}/${id}`,
                data
            }),
            invalidatesTags: ["NoteDetails"]
        }),
    }),
})

export const {
    useCreateNoteMutation,
    useUpdateNoteMutation,
    useGetNoteQuery,
    useLazyGetNoteQuery,
    useDeleteNoteMutation,
    usePinNoteMutation

} = noteApi;